module.exports = __webpack_public_path__ + "media/newstyle/images/book-type-orange-b14ffdfe328415b8b49943ccb1251c49.svg";